export const NOTIFICATIONS_SECTION_TYPE = "notification";

export const DEFAULT_DESKTOP_FONT_SIZE = 16;
export const DEFAULT_MOBILE_FONT_SIZE = 14;

export const DEFAULT_FONT_COLOR = "#FFF";
